export default {"src":"/_next/static/media/icon-arrow-left.8a43f83f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};